import { render, staticRenderFns } from "./homeDashboardCenterMonthlyStatistics.vue?vue&type=template&id=604de64a&scoped=true"
import script from "./homeDashboardCenterMonthlyStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardCenterMonthlyStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardCenterMonthlyStatistics.vue?vue&type=style&index=0&id=604de64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604de64a",
  null
  
)

export default component.exports